module.exports = __webpack_public_path__ + "img/yellow-blue.89e18f35.png";